import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useOrgLoginDialog } from '@/contexts/OrgLoginDialogContext';
import { readOrgLoginNavigationState } from '@/lib/orgLoginNavigation';

/**
 * Opens the org sign-in modal when navigation carries {@link OrgLoginNavigationState}.
 * Used after redirecting guests off `/login` onto a public org page without losing modal state.
 */
export function OrgLoginNavigationOpener() {
  const location = useLocation();
  const navigate = useNavigate();
  const { openOrgLogin } = useOrgLoginDialog();
  const handledKeyRef = useRef<string | null>(null);

  useEffect(() => {
    const navState = readOrgLoginNavigationState(location.state);
    if (!navState?.openOrgLogin) return;

    const key = `${location.key}:${navState.returnUrl ?? ''}`;
    if (handledKeyRef.current === key) return;
    handledKeyRef.current = key;

    if (navState.returnUrl) {
      openOrgLogin(navState.returnUrl);
    } else {
      openOrgLogin();
    }

    navigate(
      { pathname: location.pathname, search: location.search },
      { replace: true, state: null }
    );
  }, [location.key, location.pathname, location.search, location.state, navigate, openOrgLogin]);

  return null;
}
